"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PaginationIndicator = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PaginationIndicator = ({
  currentPage,
  totalPages
}) => {
  return /*#__PURE__*/_react.default.createElement("div", null, "Showing page ", currentPage, " of ", totalPages);
};

exports.PaginationIndicator = PaginationIndicator;
PaginationIndicator.defaultProps = {
  currentPage: "1",
  totalPages: "-"
};
PaginationIndicator.propTypes = {
  currentPage: _propTypes.default.string.isRequired,
  totalPages: _propTypes.default.string.isRequired
};
var _default = PaginationIndicator;
exports.default = _default;